import {reduxForm, Field} from 'redux-form'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import DropdownButtonSelectIcon from 'components/Fields/ReduxForm/DropdownButtonSelectIcon'
import {ActionBarWrapper} from 'components/wrappers/pages'
import MenuTitle from 'components/MenuTitle'
import {isFullSiteMode} from 'utils/fullSite'

const NAMESPACE_OPTIONS = [
  {
    id: 'items', name: 'Item Library'
  },
  {
    id: 'ingredients', name: 'Ingredients'
  }
]

class ActionBar extends React.Component {
  render () {
    let {outlets, isDirtyForm, exportButtonStatus, isIngredientActive} = this.props

    return (
      <div>
        <MenuTitle menuTitle='Transfer' />
        <div className='col-sm-4 hidden-xs col-md-6 action-transfer' style={{paddingRight: 0}}>
          <span className='pull-right'>
            { !isFullSiteMode() &&
              <button disabled={!exportButtonStatus} className='btn btn-primary' onClick={this._onClickExport}>
                Export
              </button>
            }
            <button className='btn btn-primary ml-10px' onClick={this._onClickCreateTransfer}>
              Create Transfer
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className='col-sm-12 col-xs-12' style={{paddingLeft: 0}}>
            <form className='form-inline'>
              <div className='form-group mr-5px'>
                <Field
                  name='outletIds'
                  component={DropdownOutlet}
                  outlets={outlets}
                  onChangeOutletIds={this._onChangeOutletIds}
                  allOutletOption
              />
              </div>
              <div className='form-group mr-5px'>
                <Field
                  component={DropdownCalendar}
                  name='date'
                  isDirtyForm={isDirtyForm}
                  onChange={this._onChangeDate}
                  onDirtyFormCallback={this._onChangeDate}
              />
              </div>
              <div className='form-group mr-5px'>
                <Field
                  component={DropdownButtonSelectIcon}
                  name='namespace'
                  options={NAMESPACE_OPTIONS}
                  onChange={this._onChangeNamespace}
                  isDirtyForm={isDirtyForm}
                  onDirtyFormCallback={this._onChangeNamespace}
                  disabled={!isIngredientActive}
                />
              </div>
            </form>
          </div>
        </ActionBarWrapper>
      </div>
    )
  }

  _onClickExport = () => {
    const {actionBarOnClickExport} = this.props
    actionBarOnClickExport()
  }

  _onClickCreateTransfer = () => {
    const {actionBarOnClickCreateTransfer} = this.props
    actionBarOnClickCreateTransfer()
  }

  _onChangeOutletIds = (outletIds) => {
    const {actionBarOnChangeOutletIds} = this.props
    actionBarOnChangeOutletIds(outletIds)
  }

  _onChangeDate = (values) => {
    const {actionBarOnChangeDate} = this.props
    actionBarOnChangeDate(values)
  }

  _onChangeNamespace = (event, namespace, previousNamespace) => {
    // previousNamespace is reserved for mixpanel tracking
    const {actionBarOnChangeNamespace} = this.props
    actionBarOnChangeNamespace(namespace)
  }
}

const mapForm = {
  form: 'search'
}

export default reduxForm(mapForm)(ActionBar)



// WEBPACK FOOTER //
// ./app/pages/Inventory/Transfer/ActionBar/ActionBar.js